import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/uaapi/user/";

//2fa验证项
export function get_getFaCheckItem(config?) {
  return XtAxios4.get(URL + `user/fa/getFaCheckItem`, config);
}

//2fa 单项验证检查
export function get_faCheckSendCode(config?) {
  return XtAxios4.get(URL + `user/fa/checkSendCode`, config);
}

//2fa 校验结果V2
export function get_faGetFaResultV2(config?) {
  return XtAxios4.get(URL + `user/fa/getFaResultV2`, config);
}

//发送短信邮箱验证码
export function post_msgDoSendCode(config?) {
  return XtAxios4.post(URL + `msg/doSendCode`, null, config);
}
